import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SCAN_HEART: GlameraIconDefinition = {
  name: 'scan-heart',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-scan-heart-part glm-scan-heart-corner-tr" d="M17 3h2a2 2 0 0 1 2 2v2"></path>
    <path class="glm-scan-heart-part glm-scan-heart-corner-br" d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
    <path class="glm-scan-heart-part glm-scan-heart-corner-tl" d="M3 7V5a2 2 0 0 1 2-2h2"></path>
    <path class="glm-scan-heart-part glm-scan-heart-corner-bl" d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
    <path class="glm-scan-heart-part glm-scan-heart-heart" d="M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 4.172 4.306l-3.447 3.62a1 1 0 0 1-1.449 0z"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-scan-heart-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './scan-heart.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ScanHeartIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SCAN_HEART;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
